import React from 'react';
import styled from 'styled-components';
import { AlertContent, ModalFactory } from 'components';
import { theme, toRem } from 'design';
import { OverrideWarningItem, OverrideWarningList } from './styles';

interface IOverrideWarningModalProps {
  onClose: () => void;
}

const StyledAlertContent = styled(AlertContent)`
  button[data-cy='modal-close-btn'] {
    border-color: ${theme.color.neutral[300]};
    background-color: ${theme.color.neutral[100]};

    svg {
      fill: ${theme.color.neutral[500]};
    }

    &:hover {
      background-color: ${theme.color.neutral[100]};

      svg {
        fill: ${theme.color.neutral[500]};
      }
    }
  }

  [data-cy='modal-footer'] {
    padding-top: ${toRem(theme.space.xl)};
  }
`;

export const OverrideWarningModal: React.FC<IOverrideWarningModalProps> = ({ onClose }) => (
  <ModalFactory customModal onClose={onClose} isActive>
    <StyledAlertContent
      hideLeftAction
      title="Before you override Legion labor data"
      message="This tool changes the labor Kickfin uses to calculate tips."
      rightActionLabel="I understand"
      onClose={onClose}
      onRightAction={onClose}
      maxWidth={566}
      size={47}
      dataCy="override-warning-modal"
    >
      <OverrideWarningList>
        <OverrideWarningItem>Use this only to correct labor data from Legion that is wrong.</OverrideWarningItem>
        <OverrideWarningItem>Fix the data in Legion first. Only override it here if Kickfin is still receiving the wrong data afterwards.</OverrideWarningItem>
        <OverrideWarningItem>Corrections made in Legion take about 10 minutes to reach Kickfin.</OverrideWarningItem>
        <OverrideWarningItem>Overrides affect Kickfin tip calculations only. They do not change payroll processing.</OverrideWarningItem>
      </OverrideWarningList>
    </StyledAlertContent>
  </ModalFactory>
);
